/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geotiereurope2Inputs */

const en_geotiereurope2 = /** @type {(inputs: Geotiereurope2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europe`)
};

const de_geotiereurope2 = /** @type {(inputs: Geotiereurope2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

/**
* | output |
* | --- |
* | "Europe" |
*
* @param {Geotiereurope2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geotiereurope2 = /** @type {((inputs?: Geotiereurope2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geotiereurope2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geotiereurope2(inputs)
	return de_geotiereurope2(inputs)
});
export { geotiereurope2 as "geoTierEurope" }